import { render } from "./TableIndex.vue?vue&type=template&id=54f27d56"
import script from "./TableIndex.vue?vue&type=script&lang=js"
export * from "./TableIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__